import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Library,
  Video,
  BookOpen,
  Users,
  BarChart2,
  Settings,
  ChevronLeft,
  ChevronRight,
  Cpu,
  Headset,
  Compass,
} from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { canAccessRoute } from '../../utils/rbac';
import './Sidebar.css';


const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/' },
  { icon: Library, label: 'VR Library', path: '/content-library' },
  { icon: Compass, label: 'Virtual Tours', path: '/virtual-tours' },    
  { icon: Video, label: 'Explainer Videos', path: '/explainer-videos' },
  { icon: BookOpen, label: 'Modules', path: '/modules' },
  { icon: Users, label: 'Enrollment', path: '/enrollment' },
  { icon: BarChart2, label: 'Analytics', path: '/analytics' },
];

const bottomNavItems = [
  { icon: Headset, label: 'VR Access', path: '/vr-access' },
  { icon: Settings, label: 'Settings', path: '/settings' },
];

const Sidebar = () => {
  const { sidebarCollapsed, toggleSidebar, currentUser } = useAppContext();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const filteredNavItems = navItems.filter(item => canAccessRoute(currentUser, item.path));
  const filteredBottomNavItems = bottomNavItems.filter(item => canAccessRoute(currentUser, item.path));



  return (
    <aside className={`sidebar ${sidebarCollapsed ? 'sidebar--collapsed' : ''}`}>
      {/* Logo / Brand */}
      <div className="sidebar__brand">
        <div className="sidebar__logo">
          {/* <Cpu size={28} strokeWidth={2} /> */}
          <img src="/assets/nlng-logo.png" alt="NLNG Logo" className="sidebar__logo-image" />
        </div>
        {!sidebarCollapsed && (
          <div className="sidebar__brand-text">
            <span className="sidebar__brand-name">NLNG VR LMS</span>
            <span className="sidebar__brand-sub">Training Platform</span>
          </div>
        )}
      </div>

      {/* Divider */}
      <div className="sidebar__divider" />

      {/* Main Navigation */}
      <nav className="sidebar__nav">
        {!sidebarCollapsed && (
          <span className="sidebar__nav-label">MAIN MENU</span>
        )}
        <ul className="sidebar__nav-list">
          {filteredNavItems.map(({ icon: Icon, label, path }) => (
            <li key={path} className="sidebar__nav-item">
              <NavLink
                to={path}
                className={`sidebar__nav-link tooltip ${isActive(path) ? 'sidebar__nav-link--active' : ''}`}
                data-tooltip={sidebarCollapsed ? label : ''}
              >
                <span className="sidebar__nav-icon">
                  <Icon size={19} strokeWidth={1.8} />
                </span>
                {!sidebarCollapsed && (
                  <span className="sidebar__nav-text">{label}</span>
                )}
                {!sidebarCollapsed && isActive(path) && (
                  <span className="sidebar__nav-indicator" />
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Spacer */}
      <div className="sidebar__spacer" />

      {/* Bottom Navigation */}
      <div className="sidebar__bottom">
        <div className="sidebar__divider" />
        <ul className="sidebar__nav-list">
          {filteredBottomNavItems.map(({ icon: Icon, label, path }) => (
            <li key={path} className="sidebar__nav-item">
              <NavLink
                to={path}
                className={`sidebar__nav-link tooltip ${isActive(path) ? 'sidebar__nav-link--active' : ''}`}
                data-tooltip={sidebarCollapsed ? label : ''}
              >
                <span className="sidebar__nav-icon">
                  <Icon size={19} strokeWidth={1.8} />
                </span>
                {!sidebarCollapsed && (
                  <span className="sidebar__nav-text">{label}</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Collapse Toggle */}
        <button
          className="sidebar__collapse-btn"
          onClick={toggleSidebar}
          title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <span className="sidebar__collapse-icon">
            {sidebarCollapsed ? (
              <ChevronRight size={16} strokeWidth={2.5} />
            ) : (
              <ChevronLeft size={16} strokeWidth={2.5} />
            )}
          </span>
          {!sidebarCollapsed && (
            <span className="sidebar__collapse-text">Collapse</span>
          )}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
